import { CommandListDebits } from "./commands/cmdListDebits";
import { CommandCreateDebit, CreateDebitPayload } from "./commands/cmdCreateDebit";
import { CommandUpdateDebit, UpdateDebitPayload } from "./commands/cmdUpdateDebit";
import { CommandDeleteDebit } from "./commands/cmdDeleteDebit";
import { Debit } from "@models/debit.model";

export class DebitService {
  async list(
    contractId: number,
    params?: { reporter?: string; source_type?: string },
  ): Promise<Debit[]> {
    try {
      return await new CommandListDebits().run(contractId, params);
    } catch (error) {
      console.error(`Failed to fetch debits for contract ${contractId}:`, error);
      return [];
    }
  }

  async create(contractId: number, payload: CreateDebitPayload): Promise<Debit> {
    try {
      return await new CommandCreateDebit().run(contractId, payload);
    } catch (error) {
      console.error(`Failed to create debit for contract ${contractId}:`, error);
      throw error;
    }
  }

  async update(contractId: number, debitId: number, payload: UpdateDebitPayload): Promise<Debit> {
    try {
      return await new CommandUpdateDebit().run(contractId, debitId, payload);
    } catch (error) {
      console.error(`Failed to update debit ${debitId}:`, error);
      throw error;
    }
  }

  async delete(contractId: number, debitId: number): Promise<Debit> {
    try {
      return await new CommandDeleteDebit().run(contractId, debitId);
    } catch (error) {
      console.error(`Failed to delete debit ${debitId}:`, error);
      throw error;
    }
  }
}
